import { render, staticRenderFns } from "./talentsWanted.vue?vue&type=template&id=f9abd050&scoped=true"
import script from "./talentsWanted.vue?vue&type=script&lang=js"
export * from "./talentsWanted.vue?vue&type=script&lang=js"
import style0 from "./talentsWanted.vue?vue&type=style&index=0&id=f9abd050&prod&scoped=true&lang=less"
import style1 from "./talentsWanted.vue?vue&type=style&index=1&id=f9abd050&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9abd050",
  null
  
)

export default component.exports